/* eslint-disable react/no-find-dom-node */
import React, { useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

interface IFrameProps extends React.HTMLAttributes<HTMLIFrameElement> {
    autoHeight?: boolean;
    content?: string;
    src?: string;
    minHeight?: number;
    extraMargin?: number;
    fullScreen?: boolean;
    noSandbox?: boolean;
}

const useStyles = makeStyles(() => ({
    iframeClass: {
        width: '100%',
        fontFamily: 'Arial',
        border: 0,
        overflowY: 'hidden',
        height: '35vw',
        '& img': {
            maxWidth: '100%',
            height: 'auto',
        },
        '& blockquote': {
            display: 'none',
        },
    },
    fullScreen: {
        height: '100%',
    },
}));

export const IFrame: React.FC<IFrameProps> = ({
    autoHeight,
    content,
    src,
    className,
    fullScreen,
    noSandbox,
    minHeight = 1000000,
    extraMargin = 0,
    ...props
}) => {
    const classes = useStyles();
    const [height, setHeight] = useState(100);
    const iframeRef = useRef<HTMLIFrameElement>(null);

    const handleLoad = () => {
        if (!autoHeight) return;

        const obj = iframeRef.current;
        if (!obj?.contentWindow) {
            return;
        }

        setHeight(
            Math.min(
                obj.contentWindow.document.body.scrollHeight + extraMargin,
                minHeight,
            ),
        );
    };

    const iframeHeight = autoHeight ? height : '100%';

    const classNames = classnames(classes.iframeClass, className, {
        [classes.fullScreen]: fullScreen,
    });

    const sandbox = [
        'allow-same-origin',
        'allow-popups',
        'allow-popups-to-escape-sandbox',
    ].join(' ');

    return (
        <iframe
            ref={iframeRef}
            title="iframe"
            srcDoc={content}
            src={src}
            className={classNames}
            style={{
                height: iframeHeight,
            }}
            onLoad={handleLoad}
            sandbox={noSandbox ? undefined : sandbox}
            data-testid={props['data-testid']}
        />
    );
};
